import { nanoid } from 'nanoid';
import Cookies from 'js-cookie';
import { userUtils } from '@sportheroes/oly-engine-utils';
import storage from 'utils/storage';
import { olyEngineApi } from './olyEngineApi';
export const getDeviceId = () => {
    const deviceId = storage.get('deviceId');
    if (!deviceId) {
        const newDeviceId = nanoid();
        storage.set('deviceId', newDeviceId);
        return newDeviceId;
    }
    return deviceId;
};
export const getDeviceName = () => {
    return userUtils === null || userUtils === void 0 ? void 0 : userUtils.getDeviceName(navigator === null || navigator === void 0 ? void 0 : navigator.userAgent);
};
export const getCredentials = () => {
    return {
        refreshToken: Cookies.get('zeus-admin-refreshToken') || '',
        accessToken: Cookies.get('zeus-admin-accessToken') || '',
        _id: storage.get('userId') || '',
    };
};
export const storeAccessToken = (accessToken) => {
    Cookies.set('zeus-admin-accessToken', accessToken, { expires: 730 });
};
export const storeCredentials = ({ refreshToken = '', accessToken = '', _id = '', }) => {
    Cookies.set('zeus-admin-refreshToken', refreshToken, { expires: 730 });
    Cookies.set('zeus-admin-accessToken', accessToken, { expires: 730 });
    storage.set('userId', _id);
};
export const removeCredentials = () => {
    Cookies.remove('zeus-admin-refreshToken');
    Cookies.remove('zeus-admin-accessToken');
    storage.remove('userId');
};
export const resetApiTokens = () => {
    olyEngineApi.accessToken = undefined;
    olyEngineApi.refreshToken = undefined;
};
export const setApiTokens = ({ accessToken, refreshToken }) => {
    olyEngineApi.accessToken = accessToken;
    olyEngineApi.refreshToken = refreshToken;
};
